import ReactMarkdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import 'katex/dist/katex.min.css';

type ReactMarkdownProps = React.ComponentProps<typeof ReactMarkdown>;

export function MarkdownWithMath({
  remarkPlugins,
  rehypePlugins,
  ...props
}: Omit<ReactMarkdownProps, 'remarkPlugins' | 'rehypePlugins'> & {
  remarkPlugins?: ReactMarkdownProps['remarkPlugins'];
  rehypePlugins?: ReactMarkdownProps['rehypePlugins'];
}) {
  return (
    <ReactMarkdown
      {...props}
      remarkPlugins={[remarkGfm, remarkMath, ...(remarkPlugins ?? [])]}
      rehypePlugins={[rehypeKatex, ...(rehypePlugins ?? [])]}
    />
  );
}
